import { render, staticRenderFns } from "./OtherReceivable.vue?vue&type=template&id=1e4f03ea&"
import script from "./OtherReceivable.vue?vue&type=script&lang=js&"
export * from "./OtherReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports